import React, { useState } from "react";
import styled from "styled-components";
import docData from "../utills/page_contents.json";
import { ILicenseForm, make_license } from "../api/api";

const Form = styled.form`
  display: flex;
  height: 100vh;
  justify-content: center;
  padding : 0 20%;
  flex-direction: column;
  background: #1f3cc9;
  & label {
    margin: 0.5rem 0;
    font-weight: 500;
  }
  & input {
    padding : 10px 8px;
    font-size: 0.73rem;
  }
  & select{
    padding : 10px 8px;
    font-size: 0.73rem;
  }
  & button{
    padding : 10px 8px;
    font-size: 0.73rem;
    margin-top : 1.5rem;
  }
`;
const Title = styled.h1`
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
`;
const ApiKey = styled.input``;
const DeviceKey = styled.input``;
const StoreId = styled.input``;
const PlatformSelect = styled.select``;
const ExpireDate = styled.input``;
const Button = styled.button``;

function LicenseMaker() {
  const [form, setForm] = useState<ILicenseForm>({
    api_key: "",
    device_key: "",
    store_id: "",
    device_type: "Android",
    expire_date: "2099-01-01",
  });
  const { expire_date } = form;

  const onChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const {
      currentTarget: { name, value },
    } = event;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    make_license(form);
  };

  return (
    <Form onSubmit={onSubmit}>
      <Title>License Maker</Title>

      <label>Api key</label>
      <ApiKey type="password" name='api_key' onChange={onChange} required />

      <label>Device key</label>
      <DeviceKey type="text" name='device_key' onChange={onChange} maxLength={256} required />

      <label>Store Id</label>
      <StoreId type="text" name='store_id' onChange={onChange} maxLength={256} required />

      <label>Platform</label>
      <PlatformSelect
        name='device_type'
        onChange={onChange}
        defaultValue="Android"
      >
        {docData.platforms.map((platform) => (
          <option key={platform}>{platform}</option>
        ))}
      </PlatformSelect>

      <label>Expire Date</label>
      <ExpireDate
        type="date"
        name='expire_date'
        onChange={onChange}
        defaultValue={expire_date}
        required
      />
      <Button type="submit">Generate New License</Button>
    </Form>
  );
}

export default LicenseMaker;
